<script setup>
import BaseIcon from '@/components/BaseIcon.vue'
// import OnlinePrepaymentsAndDebts from '@/components/Clients/OnlinePrepaymentsAndDebts/OnlinePrepaymentsAndDebts.vue'
import SimpleBalance from '@/components/SimpleBalance/SimpleBalance.vue'
import menuAside from '@/menuAside.js'
import { useDarkModeStore } from '@/stores/darkMode.js'
import { 
  mdiBackburger, mdiCartVariant, mdiForwardburger, mdiMenu,
  mdiAccount,
  mdiLogout,
  mdiThemeLightDark,
  mdiFoodOutline,
  mdiFoodOffOutline,
  mdiCubeOutline,
  mdiCubeOffOutline,
} from '@mdi/js'
import NotificationBar from '@/components/NotificationBar.vue'
import i18n from '../i18n'
import BaseDivider from '@/components/BaseDivider.vue'
import CardBoxModal from '@/components/CardBoxModal.vue'
import { ref, computed, reactive } from 'vue'
import { useRoute, useRouter } from 'vue-router'
// import FormControl from '@/components/FormControl.vue'
import AsideMenu from '@/components/AsideMenu/AsideMenu.vue'
import FooterBar from '@/components/FooterBar.vue'
import NavBar from '@/components/NavBar/NavBar.vue'
import NavBarItemPlain from '@/components/NavBar/NavBarItemPlain.vue'
import { useAuthStore } from '@/stores/auth_store'
import { useUserStore } from '@/stores/user_store'

const userStore = useUserStore()
const auth = useAuthStore()
const { t } = i18n.global;

// auth.testToken()
const layoutAsidePadding = 'xl:pl-60'

const darkModeStore = useDarkModeStore()

const route = useRoute()
const router = useRouter()

const isAsideMobileExpanded = ref(false)
const isAsideLgActive = ref(false)
const isModalToogleActive = ref(false)
const toogleModalTitle = ref('')
const toogleModalConfirmFunc = ref('')
const errors = reactive({
  state: false,
  errorText: '',
})
router.beforeEach(() => {
  isAsideMobileExpanded.value = false
  isAsideLgActive.value = false
})

const menuNavBar = computed(
  () => [
  // {
  //   icon: mdiMenu,
  //   label: 'Sample menu',
  //   menu: [
  //     {
  //       icon: mdiClockOutline,
  //       label: 'Item One'
  //     },
  //     {
  //       icon: mdiCloud,
  //       label: 'Item Two'
  //     },
  //     {
  //       isDivider: true
  //     },
  //     {
  //       icon: mdiCrop,
  //       label: 'Item Last'
  //     }
  //   ]
  // },
  {
    isCurrentUser: true,
    menu: [
      // {
      //   icon: mdiAccount,
      //   label: "Смена открыта",
      //   to: 'workday'
      // },
      {
        icon: mdiAccount,
        label: t('menuNavBar.myprofile'),
        to: '/profile'
      },
      // {
      //   icon: mdiCogOutline,
      //   label: 'Settings'
      // },
      // {
      //   icon: mdiEmail,
      //   label: 'Messages'
      // },
      {
        isDivider: true
      },
      {
        icon: userStore.atWork ? mdiCubeOutline : mdiCubeOffOutline,
        label: "Смена",
        isAtWork: true
      },
      {
        icon: userStore.atLunch ? mdiFoodOutline: mdiFoodOffOutline,
        label: "Обед",
        isAtLunch: true
      },
      {
        isDivider: true
      },
      {
        icon: mdiLogout,
        label: t('menuNavBar.logout'),
        isLogout: true
      }
    ]
  },
  {
    icon: mdiThemeLightDark,
    label: t('menuNavBar.lightdark'),
    isDesktopNoLabel: true,
    isToggleLightDark: true
  },
]
)
async function toogleAtWork() {
    await userStore.toogleAtWork().then(()=>{
      isModalToogleActive.value = false
    }).catch((error)=>{
      if (error.data?.reason === "active_tasks"){
        errors.errorText = "У вас есть незавершенные задачи"
        errors.state = true
      }
    })
}
async function toogleAtLunch() {
  await userStore.toogleAtLunch().then(()=>{
    isModalToogleActive.value = false
  }).catch((error)=>{
      if (error.data?.reason === "active_tasks"){
        isModalToogleActive.value = true
        errors.errorText = "У вас есть незавершенные задачи"
        errors.state = true
        toogleModalConfirmFunc.value = function(){isModalToogleActive.value = false}
      }
    })
}
const menuClick = async (event, item) => {
  if (item.isToggleLightDark) {
    darkModeStore.set()
  }

  if (item.isLogout) {
    auth.logout()
  }
  errors.state = false
  errors.errorText = ""

  if (item.isAtWork) {
    toogleModalTitle.value = "Завершить смену?"
    toogleModalConfirmFunc.value = toogleAtWork
    if (userStore.atWork) {
      isModalToogleActive.value = true
    } else {
      await toogleAtWork()
    }
  }
  if (item.isAtLunch) {
    if (userStore.atLunch) {
      toogleModalTitle.value = "Завершить обед?"
      toogleModalConfirmFunc.value = toogleAtLunch
      isModalToogleActive.value = true
    } else {
      if (userStore.atWork) {
        await toogleAtLunch()
      }
    }
  }
}
</script>

<template>
  <div
    :class="{
      'overflow-hidden lg:overflow-visible': isAsideMobileExpanded
    }"
  >
    <!-- <template v-if="userStore.can(['sales', 'cart'])">
      <router-link v-if="cartStore.cartLength && route.name !== 'cart'" :to="{ name: 'cart' }"
        ><span
          class="fixed z-50 inline-flex items-center justify-center p-5 rounded-full bg-slate-500 dark:bg-slate-300 sm:h-24 md:h-15 w-15 bottom-12 right-12"
        >
          <svg viewBox="0 0 24 24" :width="48" :height="48" class="inline-block">
            <path fill="currentColor" :d="mdiCartVariant" />
          </svg>
          <div
            class="absolute inline-flex items-center justify-center w-8 h-8 font-bold text-white bg-red-500 border-2 border-white rounded-full text-s -top-1 -end-1 dark:border-gray-900"
          >
            {{ cartStore.cartLength }}
          </div>
        </span></router-link
      >
    </template> -->
    <div
      :class="[layoutAsidePadding, { 'ml-60 lg:ml-0': isAsideMobileExpanded }]"
      class="w-screen h-full min-h-screen pt-24 transition-position lg:w-auto bg-gray-50 dark:bg-slate-800 dark:text-slate-100"
    >
      <CardBoxModal
        v-model="isModalToogleActive"
        :title="toogleModalTitle"
        has-cancel
        button-label="Завершить"
        :button-disabled="errors.state"
        @confirm="toogleModalConfirmFunc"
        widthClass='w-11/12 md:w-4/5 lg:w-3/5 xl:w-6/12'
      >
        <BaseDivider />
        <NotificationBar v-if="errors.state" color="danger">
          {{ errors.errorText }}   
        </NotificationBar>
      </CardBoxModal>

      <NavBar
        :menu="menuNavBar"
        :class="[layoutAsidePadding, { 'ml-60 lg:ml-0 ': isAsideMobileExpanded }]"
        @menu-click="menuClick"
      >
        <NavBarItemPlain
          display="flex lg:hidden "
          @click.prevent="isAsideMobileExpanded = !isAsideMobileExpanded"
        >
          <BaseIcon :path="isAsideMobileExpanded ? mdiBackburger : mdiForwardburger" size="24" />
        </NavBarItemPlain>

        <NavBarItemPlain display="hidden lg:flex xl:hidden" @click.prevent="isAsideLgActive = true">
          <BaseIcon :path="mdiMenu" size="24" />
        </NavBarItemPlain>

        <div class="flex items-center justify-start w-full xs:flex-col md:flex-row lg:flex-row">
          <SimpleBalance/>
          <!-- <OnlinePrepaymentsAndDebts
            v-if="userStore.can('online_prepayments_and_debts')"
            class="md:ml-2"
          /> -->
        </div>
        <!-- <NavBarItemPlain use-margin>
          <FormControl placeholder="Search (ctrl+k)" ctrl-k-focus transparent borderless />
        </NavBarItemPlain> -->
      </NavBar>
      <AsideMenu
        :is-aside-mobile-expanded="isAsideMobileExpanded"
        :is-aside-lg-active="isAsideLgActive"
        :menu="menuAside"
        @menu-click="menuClick"
        @aside-lg-close-click="isAsideLgActive = false"
      />
      <slot />
      <FooterBar>
      </FooterBar>
    </div>
  </div>
</template>
